const slaReadingsAllowedUserTypes = ['admin', 'homeHealth'];
export const isSlaReadingsAllowed = (userType: string) =>
  slaReadingsAllowedUserTypes.includes(userType);

const timeAssignAllowedUserTypes = ['homeHealth'];
export const isInteractiveTimeAssignAllowed = (userType: string) =>
  timeAssignAllowedUserTypes.includes(userType);
